<template>
    <form>
      <h2>Global</h2>
      <div class="divider">
      <h3>{{ $t('GlobalStyles.ReplacePalceholders') }}</h3>
      <p class="note">{{ $t('GlobalStyles.Note1') }}</p>
     <!--    <div class="placeholderGroup">
        <input type="text" id="customerId" v-model="customerId" @input="checkCustomerId" placeholder="Enter Customer ID"/>
        <span v-if="isCustomerIdValid" class="material-symbols-outlined">check_circle</span>
        </div> -->
      <!-- <div class="xmlSelection">
          <input type ="checkbox" :checked = defaultXml >Use Default XML
          <input :enabled="!defaultXml" type="file" @change="handleFileUpload" />
      </div>-->
      </div> 
        <div class="divider">
      <label for="xml-upload" class="upload-button">
          <span class="material-symbols-outlined">upload</span> XML
        </label>
        <input type="file" id="xml-upload" accept=".xml" @change="handleFileUpload" style="display: none;" />
      </div>
      <div class="divider dividerSwitch">
      
      <label class="switch">
        <input type="checkbox" :disabled="!isCustomerIdValid && !placeholdersEnabled" @change="handleToggle" v-model="placeholdersEnabled">
        <span class="slider round"></span>
      </label>
      <div v-if="!customerId"></div>
      </div>
      <h3>{{ $t('Add.General.Style') }}</h3>
      <p class="note">{{ $t('GlobalStyles.Note2') }}</p>
      <div class="divider">
        <label class="contentLabel" for="backdrop">{{ $t('GlobalStyles.BackdropColor') }}</label>
        <div class="color-container">
          <input type="color" id="backdrop" v-model="backdropColor" />
        </div>
      </div>
      <div class="divider">
        <label class="contentLabel" for="canvas">{{ $t('GlobalStyles.CanvasColor') }}</label>
        <div class="color-container">
          <input type="color" id="canvas" v-model="canvasColor" />
        </div>
      </div>
      <div class="divider">
          <label class="contentLabel" for="fontSize">{{ $t('GlobalStyles.FontSize') }}</label>
          <div class="range-container">
            <input type="range" min="1" max="40" v-model="fontSize" class="slider" id="fontSize" />
            <span>{{ fontSize }} px</span>
          </div>
        </div>
      <div class="divider">
          <p class="contentLabel">{{ $t('GlobalStyles.Font') }}</p>
          <select v-model="fontFamily" id="fontFamily">
            <option v-for="(font, key) in fontFamilyMapping" :key="key" :value="key" :style="{ fontFamily: font }">
              {{ key }}
            </option>
          </select>
        </div>
      <div class="divider">
        <label class="contentLabel" for="textC">{{ $t('GlobalStyles.TextColor') }}</label>
        <div class="color-container">
          <input type="color" id="textC" v-model="textColor" />
        </div>
      </div>
      <div class="dvider">
        <p class="contentLabel contentLabelPadding">{{ $t('Add.General.Padding') }}</p>
        <div class="range-container">
        <label for="paddingLeft"><span class="material-symbols-outlined padding">align_horizontal_left</span></label>
        <input type="range" min="0" max="100" v-model="padding.left" class="slider" id="paddingLeft" />
        <span>{{padding.left }} px</span>
        </div>
        <div class="range-container">
        <label for="paddingRight"><span class="material-symbols-outlined padding">align_horizontal_right</span></label>
        <input type="range" min="0" max="100" v-model="padding.right" class="slider" id="paddingRight" />
        <span>{{padding.right }} px</span>
        </div>
        <div class="range-container">
        <label for="paddingTop"><span class="material-symbols-outlined padding">align_vertical_top</span></label>
        <input type="range" min="0" max="100" v-model="padding.top" class="slider" id="paddingTop" />
        <span>{{padding.top }} px</span>
        </div>
        <div class="range-container">
        <label for="paddingBottom"><span class="material-symbols-outlined padding">align_vertical_bottom</span></label>
        <input type="range" min="0" max="100" v-model="padding.bottom" class="slider" id="paddingBottom" />
        <span>{{padding.bottom }} px</span>
        </div>
        </div>
    </form>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex';
  
  export default {
    data() {
      return {
        customerId: '',
        isCustomerIdValid: true,
        defaultXml : true
      };
    },
    computed: {
      ...mapState(['emailData', 'placeholdersEnabled', 'customerData']),
      backdropColor: {
        get() {
          return this.emailData?.root.data.backdropColor;
        },
        set(value) {
          if (!this.emailData.root.data) this.emailData.root.data = {};
          this.emailData.root.data.backdropColor = value;
        },
      },
      canvasColor: {
        get() {
          return this.emailData?.root.data.canvasColor;
        },
        set(value) {
          if (!this.emailData.root.data) this.emailData.root.data = {};
          this.emailData.root.data.canvasColor = value;
        },
      },
      borderColor: {
        get() {
          return this.emailData?.root.data.borderColor;
        },
        set(value) {
          if (!this.emailData.root.data) this.emailData.root.data = {};
          this.emailData.root.data.borderColor = value;
        },
      },
      textColor: {
        get() {
          return this.emailData?.root.data.textColor || 'DEFAULT' ;
        },
        set(value) {
          if (!this.emailData.root.data) this.emailData.root.data = {};
          this.emailData.root.data.textColor = value;
        },
      },
      fontFamily: {
        get() {
          return this.emailData?.root.data.fontFamily;
        },
        set(value) {
            this.emailData.root.data.fontFamily = value;
          },
      },
      fontSize: {
        get() {
          return this.emailData?.root.data.fontSize || 16;
        },
        set(value) {
          if (!this.emailData.root.data) this.emailData.root.data = {};
          this.emailData.root.data.fontSize = value;
        },
      },
      padding: {
      get() {
        return this.emailData?.root.data.padding || { top: 0, right: 0, bottom: 0, left: 0 };
      },
        set(value) {
        if (!this.emailData.root.data.padding) {
          this.emailData.root.data.padding = { top: 0, right: 0, bottom: 0, left: 0 };
        }
        this.emailData.root.data.padding = value;
      },
    },
      fontFamilyMapping() {
      return {
      BOOK_SANS: 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif',
      ORGANIC_SANS: 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif',
      GEOMETRIC_SANS: 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif',
      HEAVY_SANS: 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif',
      ROUNDED_SANS: 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif',
      MODERN_SERIF: 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif',
      BOOK_SERIF: '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif',
      MONOSPACE: '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace',
      MODERN_SANS: '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif',
      SIMPLE: 'Arial',
    };
  },
    },
    methods: {
      ...mapActions(['togglePlaceholders', 'updateXmlFile', 'addXmlToEmailData']),
      loadXmlData(xmlText) {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlText, 'application/xml');

      // Mapping erzeugen und in den Store speichern
      this.updateXmlFile(xmlDoc);
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      // XML-Datei wird als Text gelesen
      reader.onload = (e) => {
        const xmlContent = e.target.result;
        // Speichern der XML-Datei im Vuex-Store
        this.updateXmlFile(xmlContent);
        this.addXmlToEmailData (xmlContent)
      };

      // Lese die Datei als Text
      reader.readAsText(file);
    },
      handleToggle(event) {
        const enabled = event.target.checked;
        /* fetch('public/customerData/exampleData.xml') // Beispiel für Standard-XML
        .then(response => response.text())
        .then(xmlText => {
          this.loadXmlData(xmlText);  */
          this.togglePlaceholders({ customerId: 1, enabled });
        /* })
        .catch (error => console.error('Error loading default XML:', error)); */
        
      },
    },
  };
  </script>
  
  <style scoped>
@import '../../styles/addComponents.css';
  .placeholderGroup{
    display: flex;
  }
  .padding {
    margin-right: 10px;
  }
  .divider {
    margin-bottom: 35px;
  }
  form {
    text-align: left;
    font-family: 'Montserrat', sans-serif;
    padding: 10px 20px;
  }
  input {
    display: block;
  }
 /*  .range-container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  input[type="range"] {
    flex-grow: 1;
    margin-right: 10px;
    vertical-align: middle;
  } */
  .color-container {
    display: flex;
    align-items: center;
    position: relative;
  }
  .add-color-overlay {
    position: absolute;
    width: 30px;
    height: 30px;
    z-index: 5;
    border: 1px solid #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: #fff;
    padding: 0;
    margin-left: 5px;
    margin-top: 5px;
    pointer-events: none;
  }
  input[type="color"] {
    width: 30px;
    height: 30px;
    border-radius: 15%;
    padding: 0;
    margin-left: 5px;
    position: relative;
    z-index: 1;
    border: 1px solid gray;
  }
  input[type="color"]::-webkit-color-swatch-wrapper {
    padding: 0;
  }
  input[type="color"]::-webkit-color-swatch {
    border: none;
  }
  .reset-color {
    cursor: pointer;
    margin-left: 10px;
    margin-top: 5px;
  }
  textarea {
    width: 90%;
    margin-top: 5px;
  }
  
  .contentLabel {
    font: 15px;
    margin-bottom: 7px;
  }
  
  select {
    display: block;
    margin-left: 0;
    padding: 10px 0px;
    width: 100%;
    box-sizing: border-box;
    border: none;
    border-bottom: 1px solid #ddd;
    color: #555;
  }
  
  .note {
    color: gray;
    font-size: 14px;
    font-style: italic;
  }
  
  .switch {
    position: relative;
    display: inline-block;
    width: 52px;
    height: 27px;
    margin-right: 10px;
    
  }
  
  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 3px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  input:checked + .slider {
    background-color:var(--primary-color);
  }
  
  input:focus + .slider {
    box-shadow: 0 0 1px var(--primary-color);
  }
  
  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
  
  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }
  
  .slider.round:before {
    border-radius: 50%;
  }
  

  .dividerSwitch{
    display: flex;
    align-items: center;
  }

  .upload-button {
  cursor: pointer;
  padding: 10px 20px;
  color: white;
  background-color: #ccc;
  border: none;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  font-size: 16px;
}

.upload-button span {
  margin-right: 8px;
  font-size: 24px;
}

.upload-button:hover{
  cursor: pointer;
  background-color: darkgray;  
}
  </style>
  